import { faInfoCircle, faReceipt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import apiMethods from '../../constants/apiMethods';
import colors from '../../constants/colors';
import alertMessages from '../../helpers/alertMessages';
import api from '../../helpers/api';
import es from '../../lang/es';

import PaymentInfo from './PaymentInfo';

const PaymentActions = ({payment, endFunction}) => {
    //Inicializo el state local
    const [ showInfo, setShowInfo ] = useState(false);
    //Función que cierra
    const handleCloseInfo = () => {
        setShowInfo(false);
    }
    //Función que muestra
    const handleShowInfo = () => {
        setShowInfo(true);
    }
    //Función para ver comprobante
    const handleReceipt = () => {
        const response = {
            file: payment.payment_lot.voucher
        };

        window.open(response.file);
    }
    //Función para eliminar
    const handleDelete = () => {
        //Inicializo
        const data = {
            title: es.CONFIRMATION.PAYMENT_DELETE,
            text: es.SUBMESSAGES.PAYMENT_DELETE,
            confirmColor: colors.red,
            confirmText: es.DELETE,
            callback: async () => {
                try{
                    //Cargo la espera
                    alertMessages.waiting(es.LOADINGS.DELETE);
                    //Hago la consulta
                    await api.delete(apiMethods.PAYMENT_DELETE(payment.id));
                    //Oculto la espera
                    alertMessages.close();
                    //Me fijo si hay función para el final
                    if(typeof endFunction !== "undefined" && typeof endFunction === "function"){
                        //Ejecuto la función
                        endFunction();
                    }
                }catch(error){
                    const errorResponse = error.response;
                    //Inicializo
                    let errorData = {
                        data: null,
                        message: es.ERRORS.SERVER_CONN
                    };
                    //Verifico si hay error
                    if(errorResponse){
                        errorData = errorResponse.data;
                    }
                    //Muestro mensaje de error
                    alertMessages.error(errorData.message);
                }
            }
        };
        //Confirmación
        alertMessages.confirm(data);
    }
    //Render
    return (
        <>
        {
            payment.can_delete ? (
                <OverlayTrigger
                    overlay={
                        <Tooltip>{ es.DELETE }</Tooltip>
                    }
                    placement="left"
                >
                    <Button variant="danger" size="sm" onClick={handleDelete} className="mt-2 mt-md-0">
                        <FontAwesomeIcon icon={faTrashAlt} /> <span className='d-md-none'>{ es.DELETE }</span>
                    </Button>
                </OverlayTrigger>
            ) : (
                <React.Fragment>
                    <OverlayTrigger
                        overlay={
                            <Tooltip>{ es.PAYMENTS.INFO }</Tooltip>
                        }
                        placement="left"
                    >
                        <Button variant="info" size="sm" onClick={handleShowInfo} className="mt-2 mt-md-0">
                            <span>
                                <FontAwesomeIcon icon={faInfoCircle} /> <span className='d-md-none'>{ es.PAYMENTS.INFO }</span>
                            </span>                    
                        </Button>
                    </OverlayTrigger>

                    <PaymentInfo
                        show={showInfo} 
                        handleClose={handleCloseInfo} 
                        payment={payment} 
                    />
                </React.Fragment>
            )
        }
        {
            payment.payment_lot && payment.payment_lot.voucher ? (
                <OverlayTrigger
                    overlay={
                        <Tooltip>
                            { es.PAYMENTS.TICKET }
                        </Tooltip>
                    }
                >
                    <Button variant="dark" className="mt-2 mt-md-0 ml-2" size="sm" onClick={handleReceipt}>
                        <FontAwesomeIcon icon={faReceipt} /> <span className='d-md-none'>{ es.PAYMENTS.TICKET }</span>
                    </Button>
                </OverlayTrigger>
            ) : null
        }
        </>
    );
};

export default PaymentActions;